import { Box, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import logo from '../../../containers/member/assets/img/logo-powered-by.svg';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';

function Footer() {
  const t = useCommonTranslation();
  return (
    <>
      <footer>
        <img src={logo} alt={t('member.logoAlt')} className="logo" />
        <span className="spacer" />
        <div className="links">
          <Typography variant="body1" color="white">
            {t('member.footerQuestions')} <span> </span>
            <Box
              component="span"
              sx={{ display: { xs: 'block', sm: 'inline' } }}>
              {t('member.footerCallUsText')}{' '}
              <a href={`tel:${t('footer.phoneNumber')}`}>
                {t('footer.phoneNumber')}
              </a>
            </Box>
          </Typography>

          <NavLink to="https://americanlogistics.com/privacy/">
            {t('member.privacyTerms')}
          </NavLink>
        </div>
      </footer>
    </>
  );
}

export default Footer;
